import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Two-letter uppercase initials from a name (e.g. "Sanne de Wit" → "SW").
 * Returns the "–" fallback for missing names (null/undefined/empty), since
 * imported real-world data may leave actor/contact names unset.
 */
export function initials(name: string | null | undefined): string {
  if (!name) return "–"
  const words = name.trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) return "–"
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase()
  return (words[0][0] + words[words.length - 1][0]).toUpperCase()
}
